export enum OrderTrackingMessage {
    Success = 'ORDER_TRACKING_SUCCESS',
    OrderNotFound = 'ORDER_NOT_FOUND',
    InvalidVerificationCode = 'INVALID_VERIFICATION_CODE'
}

export const ANONYMOUS_DELIVERY_OTHER_DELIVERIES_PAGE_SIZE = 4;

export const ANONYMOUS_DELIVERY_SESSION_STORAGE_KEY_PREFIX = 'lxs-anonymous-delivery:';
